module.exports = [{
      plugin: require('/Users/pmahmud/dev/projects/chorki/docs/src/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
